<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { textAboveBackground } = $AppState.theme.colors;

  export let color = textAboveBackground;
</script>

<svg
  class="twism-collapsed-svg-trophy"
  width="40"
  height="40"
  viewBox="0 0 40 40"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M28.9998 6H10.9998C10.9998 6 9.83569 14.583 10.9998 19.875C12.3788 26.1438 16.9998 28.5 16.9998 28.5V36H22.9998V28.5C22.9998 28.5 27.6208 26.1438 28.9998 19.875C30.1639 14.583 28.9998 6 28.9998 6Z"
    stroke={color}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
  <path
    d="M36.3369 11.6414L37.0794 11.7475L36.3369 11.6414ZM29.75 11.25H35.347V9.75H29.75V11.25ZM35.5945 11.5354L34.9149 16.2925L36.3998 16.5046L37.0794 11.7475L35.5945 11.5354ZM30.2974 20.7679L28.1672 21.0046L28.3328 22.4954L30.4631 22.2587L30.2974 20.7679ZM34.9149 16.2925C34.5763 18.6626 32.677 20.5035 30.2974 20.7679L30.4631 22.2587C33.5225 21.9188 35.9645 19.552 36.3998 16.5046L34.9149 16.2925ZM35.347 11.25C35.4991 11.25 35.616 11.3847 35.5945 11.5354L37.0794 11.7475C37.23 10.6932 36.412 9.75 35.347 9.75V11.25Z"
    fill={color}
  />
  <path
    d="M3.66306 11.6414L2.9206 11.7475L3.66306 11.6414ZM10.25 11.25H4.65301V9.75H10.25V11.25ZM4.40552 11.5354L5.08511 16.2925L3.60019 16.5046L2.9206 11.7475L4.40552 11.5354ZM9.70258 20.7679L11.8328 21.0046L11.6672 22.4954L9.53693 22.2587L9.70258 20.7679ZM5.08511 16.2925C5.42371 18.6626 7.32299 20.5035 9.70258 20.7679L9.53693 22.2587C6.47745 21.9188 4.03552 19.552 3.60019 16.5046L5.08511 16.2925ZM4.65301 11.25C4.50087 11.25 4.38401 11.3847 4.40552 11.5354L2.9206 11.7475C2.76999 10.6932 3.58805 9.75 4.65301 9.75V11.25Z"
    fill={color}
  />
  <path
    d="M11 36H29"
    stroke={color}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>

<style lang="scss">
  .twism-collapsed-svg-trophy {
    @media screen and (max-width: 468px) {
      width: 36px !important;
      height: 30px !important;
    }
  }
</style>
